// src/components/SvgIcon.tsx
import React from "react";

interface SvgIconProps {
	src: string;                 // either raw <svg>…</svg> or a full data URI
	width?: number | string;     // e.g. 40 or "2rem"
	height?: number | string;
	className?: string;
}

const SvgIcon: React.FC<SvgIconProps> = ({
	src,
	width = 40,
	height = 40,
	className,
}) => {
	// if it's a raw SVG string (starts with "<svg"), encode it;
	// otherwise assume it's already a data URI and pass it through
	const srcContent = src.trim().startsWith("<")
		? `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(src)))}`
		: src;

	return (
		<img
			className={className}
			src={srcContent}
			width={width}
			height={height}
			alt=""
			style={{ display: "inline-block" }}
		/>
	);
};

export default SvgIcon;
